"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.prompt-assist.disabled': 'Prompt assist feature is not available in your current plan.',
};
